import { render, staticRenderFns } from "./Astudent.vue?vue&type=template&id=6c772480"
import script from "./Astudent.vue?vue&type=script&lang=js"
export * from "./Astudent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports